module.exports = __webpack_public_path__ + "static/media/18.33d1d3b.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/18.wav
// module id = YsKn
// module chunks = 0